import Util from '@/lib/util'
export default [
    {
        title:Util.L('Warehouse'),
        key:'warehouseName',
        width:150
    }
]